export enum EvidenceRecordStatus {
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  ERROR = 'ERROR'
}

export enum EvidenceRecordGroupByType {
  LIST = 'LIST',
  DOCUMENT_TYPES = 'DOCUMENT_TYPES',
  COUNTRIES = 'COUNTRIES',
  PRODUCTS_SERVICES_CLASSES = 'PRODUCTS_SERVICES_CLASSES',
  LANGUAGES = 'LANGUAGES',
  YEARS = 'YEARS'
}

export enum MIMEType {
  ZIP = 'application/zip',
  PDF = 'application/pdf'
}

export function getExtensionOfMIME(mimeType: MIMEType): string {
  switch (mimeType) {
    case MIMEType.ZIP: return '.zip';
    case MIMEType.PDF: return '.pdf';
    default: return '';
  }
}

export interface EvidenceRecord {
  _id?: string;
  name: string,
  case: string
  status: EvidenceRecordStatus,
  documents: string[];
  groupBy: EvidenceRecordGroupByType[];
  createdAt: Date;
  generatedAt?: Date
  createdBy: {
    ref: string;
    firstName: string;
    lastName: string;
    avatar: string;
  };
  url?: string;
  mimeType?: MIMEType;
}
